import {useState} from 'react';
import {useTranslation} from "react-i18next";
import {Input, Listbox, ListboxItem} from "@nextui-org/react";
import {SearchIcon} from "../../icons/SearchIcon";
import Header from "../../reusable/Header";
import PoweredBy from "../../reusable/PoweredBy";
import {Countries} from "./Contries";

function CountrySelect({onSelect, heading, subheading}) {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');

    const filteredOptions = Countries == null ? [] : Countries?.filter(option =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelect = (selected) => {
        if (selected) {
            onSelect(selected.values().next().value)
        }
    }

    return (
        <div className="flex h-full flex-col">
            {/* Header */}
            <Header />
            <div className="px-4 pb-3 flex flex-col gap-1">
                <div className="heading text-xl text-center">{heading ?? t("documentUpload.countrySelect.heading")}</div>
                <div className="desc text-sm text-center" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{subheading ?? t("documentUpload.countrySelect.subheading")}</div>
            </div>

            {/* Search */}
            <div className="px-4 pb-2">
                <Input
                    type="text"
                    placeholder={t("documentUpload.countrySelect.searchPlaceholder")}
                    radius="sm"
                    variant="bordered"
                    color="primary"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    classNames={{ input: "!text-base" }}
                    startContent={
                        <SearchIcon
                            className="pointer-events-none flex-shrink-0"
                            style={{ color: "var(--urtentic-sdk-primary, #255CFF)" }}
                        />
                    }
                />
            </div>

            {/* Scrollable list */}
            <div className="flex-grow overflow-auto px-4">
                <Listbox
                    aria-label="Country selection"
                    variant="flat"
                    disallowEmptySelection
                    virtualization={{maxListboxHeight: 400, itemHeight: 64}}
                    selectionMode="single"
                    onSelectionChange={handleSelect}
                >
                    {filteredOptions.map((country) => (
                        <ListboxItem
                            key={`${JSON.stringify(country)}`}
                            showDivider
                            className="py-3"
                            startContent={<span className="text-xl">{country.flag}</span>}
                        >
                            <span style={{color: "var(--urtentic-sdk-body, #737373)"}}>{country.name}</span>
                        </ListboxItem>
                    ))}
                </Listbox>
            </div>

            {/* Footer */}
            <div className="flex justify-center p-2">
                <PoweredBy />
            </div>
        </div>
    );
}

export default CountrySelect;
